/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aicostsmonthcredits3Inputs */

const en_aicostsmonthcredits3 = /** @type {(inputs: Aicostsmonthcredits3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Credits paid this month`)
};

const de_aicostsmonthcredits3 = /** @type {(inputs: Aicostsmonthcredits3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bezahlte Credits im Monat`)
};

/**
* | output |
* | --- |
* | "Credits paid this month" |
*
* @param {Aicostsmonthcredits3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aicostsmonthcredits3 = /** @type {((inputs?: Aicostsmonthcredits3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aicostsmonthcredits3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aicostsmonthcredits3(inputs)
	return de_aicostsmonthcredits3(inputs)
});
export { aicostsmonthcredits3 as "aiCostsMonthCredits" }